import { useEffect } from "react";

/**
 * The API shares the app's origin. A link inside the app to one of its paths loads it from the
 * server, rather than showing the app's not-found screen.
 */
export const ServerRoute = () => {
    useEffect(() => {
        window.location.replace(window.location.href);
    }, []);

    return null;
};
